<template>
  <ebt-card />
  <payment @valid="handleValidation" />
</template>

<script setup lang="ts">
import Payment from '@/components/Main/Operator/Registration/Payment.vue';
import EbtCard from '@/components/Main/Operator/Grocery/Registration/EbtCard/EbtCard.vue';

const emit = defineEmits(['valid']);
const handleValidation = (isValid: boolean) => {
  emit('valid', isValid);
};
</script>

<style scoped lang="scss"></style>
